import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useTenantGroup } from '../../hooks/useTenantGroup'
import { DetailEntityPage } from '../DetailEntityPage/DetailEntityPage'
import { AvailabilityBadge } from '../../components/AvailabilityBadge/AvailabilityBadge'
import { formatDate } from '../../helpers/formatDate'
import type { DetailFieldDef } from '../../types'

export function TenantGroupDetailPage() {
  const { id } = useParams<{ id: string }>()
  const { tenantGroup, isLoading, error } = useTenantGroup(id ?? '')

  const fields: DetailFieldDef[] = tenantGroup
    ? [
        {
          label: 'ID',
          value: <span className="font-monospace small">{tenantGroup.id}</span>,
        },
        {
          label: 'Code',
          value: <span className="fw-medium">{tenantGroup.code}</span>,
        },
        { label: 'Name', value: tenantGroup.name },
        { label: 'Type', value: tenantGroup.type },
        {
          label: 'Availability Build',
          value: (
            <AvailabilityBadge enabled={tenantGroup.availabilityBuildEnabled} />
          ),
        },
        { label: 'Created', value: formatDate(tenantGroup.createdAt) },
        { label: 'Updated', value: formatDate(tenantGroup.updatedAt) },
      ]
    : []

  return (
    <DetailEntityPage
      title={
        tenantGroup ? `Tenant Group - ${tenantGroup.code}` : 'Tenant Group'
      }
      loadingLabel="tenant group"
      fields={fields}
      isLoading={isLoading}
      error={error}
      actions={
        id ? (
          <Link
            to={`/tenant-groups/${id}/edit`}
            className="btn btn-primary btn-sm"
          >
            Edit
          </Link>
        ) : undefined
      }
    />
  )
}
